import { IAuctionBet, IPromotionState } from '../types';
import { IPublishTermsSuccessPayload } from '../../../../actions/publishTerms';

export const mergeAuctionBet = (state: IPromotionState, payload: IPublishTermsSuccessPayload): IAuctionBet => {
  if (state.isChangedByUser) {
    return {
      ...state.auctionBet,
      ...payload.dataV2.promotion.auctionBet,
      value: state.auctionBet.value,
    };
  }

  return payload.dataV2.promotion.auctionBet;
};
